// ============================================
// COMPONENT - Filas de skeleton para tablas en carga
// ============================================

import { Skeleton } from '@almacenes/ui';

interface TableSkeletonRowsProps {
  columns: number;
  rows?: number;
}

export const TableSkeletonRows = ({ columns, rows = 5 }: TableSkeletonRowsProps) => (
  <>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
        {Array.from({ length: columns }).map((__, colIndex) => (
          <td key={colIndex} className="px-6 py-3">
            <Skeleton className="h-4 w-full" />
          </td>
        ))}
      </tr>
    ))}
  </>
);
